import { useQuery } from '@tanstack/react-query';
import { axiosRequest } from '@lib/axios';

/**
 * React Query wrapper for the Curricula query.
 */
const useCurriculaQuery = () => {
  const query = useQuery({
    queryKey: ['curricula'],
    queryFn: () => axiosRequest({
      method: 'GET',
      url: 'curricula',
    }),
    structuralSharing: false,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
    select: (curricula) => {
      if (!curricula || curricula.length < 1) {
        return null;
      }
      curricula.forEach((cur) => {
        cur.additional = cur?.additional?.map((a) => a.curriculumAdditional);
        cur.program_areas = cur?.lessons?.reduce((acc, lesson) => {
          ['snap_ed', 'efnep', 'cphp'].forEach((key) => {
            if (lesson[key] && !acc.includes(key)) {
              acc.push(key);
            }
          });
          return acc;
        }, []);
      });
      curricula.sort((a, b) => a.name.localeCompare(b.name));
      return curricula;
    }
  });

  return {
    data: query.isLoading ? null : query.data,
    ...query,
  }
};

export default useCurriculaQuery;
